const TYPE_NAMES = {
  TRANSACTION_PURPOSE: 'Transaction Purpose',
  TYPE_OF_ACTIVITY: 'Type of activity',
  TYPE: 'Type',
};

export default TYPE_NAMES;
